<template>
  <div class="px-6 px-lg-14 pt-6 pt-lg-10">
    <v-btn
        class="addButton"
        fab
        dark
        large
        elevation="0"
        color="black"
        @click.stop="
            showingFileDialog = true;"
    >
      <img width='35%' height='auto' src="../assets/img/svg/icons/add.svg">
    </v-btn>

    <div v-if="showingFileDialog" class="position-fixed d-flex justify-content-center align-items-center left-0 top-0 w-100 h-100" style="background-color: rgb(0, 0, 0, 0.3)">
      <div class="text-center border-solid border-thin rounded p-4 px-xl-5 bg-white" style="border-color: #DDD;">
        <div class="text-h6 text-uppercase mb-5">{{ $t("select_file") }}</div>

        <v-file-input class="mb-5" v-model="importFile" label="Import.zip"></v-file-input>

        <v-btn class="d-block w-100 my-2 bg-primary text-white" elevation="0" :disabled="importFile == null" :loading="inProgress" @click="executeImport">{{ $t("start_import") }}</v-btn>
        <v-btn class="d-block w-100 my-2" elevation="0" @click="showingFileDialog = false;" :disabled="inProgress">{{ $t("cancel") }}</v-btn>
        <!-- <v-btn class="d-block w-100 my-2" elevation="0" @click="clearFolders" :disabled="inProgress">clear Folders</v-btn>
        <v-btn class="d-block w-100 my-2" elevation="0" @click="fixMeasurements" :disabled="inProgress">fix drivingband</v-btn> -->
      </div>
    </div>

    <div class="mx-0 pb-6 pb-lg-10 row align-items-end">
      <div class="text-h4 text-uppercase">{{ $t("import") }}</div>

      <div class="text-right" v-if="rightGlobalAccess">
        <v-btn
            outlined
            class="rounded-0"
            @click="triggerExport()"
        >
          {{ $t("export_file") }}
        </v-btn>
      </div>
    </div>

    <div class="page-content">
      <v-simple-table id="Findings" class="findingstable importtable">
        <thead>
        <tr>
          <th>{{ $t("operation") }}</th>
          <th>{{ $t("status_import") }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="row in report">
          <td>{{ $t(row.title) }}</td>
          <td>{{ row.status == null ? 'OK' : $t(row.status) }}</td>
        </tr>
        </tbody>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "import",

  data() {
    return {
      showingFileDialog: true,
      importFile: null,
      inProgress: false,
      report: [],
      rightGlobalAccess: false,
      me: null
    }
  },

  mounted() {
    showLoadingCircle(false);
    this.fetchMe();
  },

  methods: {
    async fetchMe() {
      var _this = this;
      await this.$axios
          .get("api/me")
          .then(function (response) {
            _this.me = response.data;
            _this.rightGlobalAccess = _this.hasRight("GlobalAccess");
          })
          .catch(this.onError);
    },
    hasRight(right) {
      if (this.me.rights.includes(right)) return true;
      if (this.me.role != null) {
        return this.me.role.rights.includes(right);
      }
      return false;
    },
    async executeImport() {
      this.$noty.error('<i class="fas fa-minus-circle mr-3"></i>' + "Import Funktion deaktiviert. An Admin wenden um diese erneut zu aktivieren.");
      // this.inProgress = true;

      // try { // fix/materials /deduplicated /fix/nations /link/images /fix/sources
      //   const response = await this.$axios.post("api/import/fix/sources", this.importFile, {
      //     headers: { 'Content-Type': 'application/x-zip' }
      //   });
      //   this.report = response.data;
      //   this.importFile = null;
      //   this.showingFileDialog = false;
      // }
      // catch (e) {
      // }

      // this.inProgress = false;
    },
    clearFolders() {
      var _this = this;
      this.$axios
        .post("api/import/clear-folders")
        .then(function (response) {
          _this.report = response.data;
          _this.showingFileDialog = false;
        })
        .catch(this.onError)
        .finally(this.inProgress = false);
    },
    fixMeasurements() {
      var _this = this;
      this.$axios
        .post("api/import/fix/drivingband")
        .then(function (response) {
          _this.report = response.data;
          _this.showingFileDialog = false;
        })
        .catch(this.onError)
        .finally(this.inProgress = false);
    },
    triggerExport() {
      this.$axios.get("api/export/generate")
          .then(() => {})
          .catch(() => {});

      this.$noty.success(this.$t("export_started")).setTimeout(1000);
    },
  }
}
</script>

<style scoped>

</style>
